/**
 * Format milliseconds to MM:SS format
 * @param {number} milliseconds - Duration in milliseconds
 * @returns {string} Formatted time string (e.g., "02:35")
 */
export function formatTime(milliseconds) {
  const seconds = Math.floor(milliseconds / 1000)
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60

  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
}
